<template>
  <div class="page-body tron-body">
    <div class="page-content">
      <div class="page-container">

        <van-nav-bar class="u-p-tb-10 bg-none">
          <template #title>
            <span class="u-font-16 font-bold text-white">{{ $t('收款') }}</span>
          </template>
        </van-nav-bar>

        <div v-if="orders" class="card">
          <div class="card-content">
            <div class="qrcode-title">{{ $t('扫描二维码') }}，{{ $t('转入') }}<span id="amount" style="color: inherit;font-size: inherit;"></span>{{ orders.coinCode }}</div>
            <div v-if="no" class="">{{ $t('单号') }}：{{ no }}</div>
            <div v-if="orders.money" class="u-p-tb-10" >{{ $t('金额') }}：{{ orders.money }}</div>
            <div class="qrcode-code">
              <div id="qrcode" class="d-flex justify-center"></div>
            </div>
            <div class="qrcode-link" @click="copyText($event, orders.toAddress)">
              <p>{{ $t('钱包地址') }}</p>
              <p id="address">{{ orders.toAddress }}</p>
            </div>
          </div>
          <div class="card-footer">
            <div class="qrcode-warp" @click="copyText($event, orders.toAddress)">
              <div class="qrcode-item">
                <i class="icon icon-copy"></i><span>{{ $t('复制') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-else>
          <div class="card-content">
            <div v-if="no" class="qrcode-title">{{ $t('单号') }}：{{ no }}</div>
            <div class="u-p-tb-60">
              <div>{{ $t('无效订单') }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'

export default {
  name: "TrcQrcode",
  computed: {
  },
  data() {
    return {
      no: null,
      orders: {},
    }
  },
  created() {
    // this.no = this.$route.query.no
    // this.getOrdersInfo()
    this.orders = {...this.$route.query}
    this.getQrcode(this.orders.toAddress)
  },
  methods: {
    // getOrdersInfo() {
    //   this.$get(`/pay/orders/${this.no}/payInfo`).then(res => {
    //     this.orders = res.data
    //     this.orders && this.getQrcode(this.orders.toAddress)
    //   })
    // },
    // 生成二维码
    getQrcode(url, ele = 'qrcode') {
      this.$nextTick(() => {
        new QRCode(ele, {
          text: url,
          width: 200,  // 设置宽度
          height: 200, // 设置高度colorDark : "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L
        });
      })
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  .van-nav-bar {
    background: none;
  }

  .van-grid-item__content:after,
  .van-hairline--bottom:after,
  .van-hairline--top-bottom:after,
  .van-hairline--top:after,
  .van-hairline-unset--top-bottom:after {
    border: none !important;
    content: "";
  }
}

.page-body {
  width: 100%;
  height: 120vh;
  overflow: hidden;
  margin: 0 auto;

  .page-container {
  }

  .page-content {
  }
}

.tron-body {
  background-color: #3C73FC;
  min-height: 120vh;

  .card {
    background: #fff;
    box-shadow: none;
    margin: 1.333rem 0.373333rem;
    border-radius: 0.266666rem;
    font-size: 0.373333rem;

    .card-footer, .card-header {
      min-height: 44px;
      position: relative;
      padding: 10px 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .card-header {
      padding: 0.506666rem 0.4rem;
      font-size: 0.373333rem;
      color: #333;
    }

    .card-content {
      position: relative;
      padding: 0 0.7rem;
      text-align: center;

      .qrcode-title {
        line-height: 0.64rem;
        padding-top: 1.1rem;
        padding-bottom: 0.6rem;
        color: #bebebe;
      }

      .qrcode-code {
        width: 200px;
        height: 200px;
        margin: 0 auto;
        padding: 0.4rem;
      }

      .qrcode-link {
        padding-top: 0.8rem;
        padding-bottom: 0.5rem;

        p {
          font-size: 0.5rem;
          line-height: 0.48rem;
          color: #bebebe;
          word-wrap: break-word;
          word-break: break-all;

          &:last-child {
            padding-top: 0.133333rem;
            color: #333333;
          }
        }
      }
    }

    .card-footer {
      color: #6d6d72;
      padding: 0.4rem 0;
      background-color: #f7f6fb;
      border-radius: 0 0 0.266666rem 0.266666rem;

      .qrcode-warp {
        display: flex;
        box-sizing: border-box;
        align-items: center;
        width: 100%;
        text-align: center;

        .qrcode-item {
          position: relative;
          flex: 1;

          &:before {
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 1px;
            height: 0.373333rem;
            background-color: #dadbdf;
          }

          .more {
            position: relative;
            top: -0.1rem;
            line-height: 0.32rem;
            font-size: 0.64rem;
            color: #333333;
          }
        }
      }
    }
  }
}

</style>
